const timeout = 30000;
const configs = {
    'development': {
        "baseUrl": "http://localhost:1338/api/v2/",
        'timeout': timeout,
    },
    'production': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'staging': {
        //"baseUrl": "http://localhost:1338/api/v2/",
        'baseUrl': 'https://test-contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'demo': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        //"baseUrl": "http://localhost:1338/api/v2/",
        'timeout': timeout,
    },
    'stresidences': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'escape2thesands': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'youarehome': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'ldg': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'clarendon': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'signetapartments': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'charmstay': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'cosmopolitanapartments': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'citystayapartment': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'roomspace': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'harrogateapartments': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'tempstay': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'kepplestonemanor': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'scandik': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'bnbme': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'multicurrencytest2': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'multicurrencytest': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'tjpad': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'flyingbutler': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'sixstays': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'zomelle': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'buckinghamandlloyds': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'domusstay': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'qapartments': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'markeygroup': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'mabaat': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'week2week': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'thecollectivelive': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'thecollective': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'citywestaparthotel': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'khhomes': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'basilstreetapartments': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'homa': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    'noonsg': {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
    "briscoeandshaw": {
        'baseUrl': 'https://contact-api.rerumapp.uk/api/v2/',
        'timeout': timeout,
    },
};

export default function(env) {
    if (configs[env] !== undefined) {
        return configs[env];
    }
    return configs.development;
}
